import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseTableComponent } from '@fuse/components/table/table.component';
import { FilterItemDirective } from '@fuse/directives/filter-item';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import {fetchFieldsPipe} from './table.pipe';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import {MatChipsModule} from '@angular/material/chips';
import { TranslocoModule } from '@ngneat/transloco';


@NgModule({
    declarations: [
        FuseTableComponent,
        FilterItemDirective,
        fetchFieldsPipe,
    ],
    imports     : [
        CommonModule,
        TableModule,
        CalendarModule,
        SliderModule,
        DialogModule,
        MultiSelectModule,
        ContextMenuModule,
        ButtonModule,
        ToastModule,
        InputTextModule,
        ProgressBarModule,
        DropdownModule,
        SplitButtonModule,
        MatMenuModule,
        MatIconModule,
        FormsModule,
        MatChipsModule,
        TranslocoModule
    ],
    exports     : [
        FuseTableComponent,
    ],
    providers   :[
        fetchFieldsPipe,
    ]
})
export class FuseTableModule
{
}
